module.exports = __webpack_public_path__ + "img/kakeibo-budget-planner_B09K1TWT9T.ca41c125.jpg";